import { IRollSelectBehavior } from "./IRollSelectBehavior";

export interface IRollSelectBehaviorSpecifiable {
  rollSelectBehavior: IRollSelectBehavior;
}

export function instanceOfIRollSelectBehaviorSpecifiable(instance: any): instance is IRollSelectBehaviorSpecifiable {
  return instance
    && (instance.rollSelectBehavior !== undefined);
}
